import { useCookie } from "nuxt/app";

export function scrollToElement(elementId: string, offset: number = 0) {
  const element = document.getElementById(elementId);
  if (element) {
    const targetPosition =
      element.getBoundingClientRect().top + document.body.scrollTop - offset;
    document.body.scrollTo({ top: targetPosition, behavior: "smooth" });
  }
}

export function validateEmailFormat(email: string) {
  if (email.length > 1) {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  }
}

export function resizeSloganFontSizeToFit(text: string) {
  const fontSize = 5;
  return 100 / text.length + fontSize + "vw";
}
export function sloganFontSizeFull(
  text: string,
  parent: any,
  parentWidth: any,
  testDiv: any
) {
  let fontSize = 30;
  while (testDiv.clientWidth < parentWidth) {
    fontSize += 1;
    testDiv.style.position = "absolute";
    testDiv.style.fontWeight = 800;
    testDiv.style.bottom = 0;
    testDiv.style.visibility = "hidden";
    testDiv.style.whiteSpace = "nowrap";
    testDiv.style.fontSize = `${fontSize}px`;
    testDiv.innerText = text;
    parent?.appendChild(testDiv);
    testDiv.style.fontSize = `${fontSize}px`;
  }
  while (testDiv.clientWidth > parentWidth) {
    fontSize -= 1;
    testDiv.style.position = "absolute";
    testDiv.style.bottom = 0;
    testDiv.style.visibility = "hidden";
    testDiv.style.whiteSpace = "nowrap";
    testDiv.style.fontSize = `${fontSize}px`;
    testDiv.innerText = text;
    parent?.appendChild(testDiv);
    testDiv.style.fontSize = `${fontSize}px`;
  }
  parent?.removeChild(testDiv);
  return fontSize;
}

export function offPercentCalculator(marketAmount: number, amount: number) {
  let difference = marketAmount - amount;
  // Calculate the percentage off
  let percent = (difference / marketAmount) * 100;

  return +percent.toFixed();
}

export function formatPrice(value: number) {
  const locale = useCookie("locale").value || "en";
  const currency = useCookie("currency").value;

  if (currency == "IRT") {
    return value?.toLocaleString(locale);
  } else {
    return value % 1 === 0
      ? value.toLocaleString(locale)
      : value?.toLocaleString(locale, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
  }
}
